import React from 'react';
import PropTypes from 'prop-types';

import Icon from 'relements/build/esm/ui/icon';

import Info from './icons/info.svg';
import Error from './icons/error.svg';
import styles from './InfoTooltip.scss';

/**
 * Renders blue colored information type tooltip
 * This tooltip is always visible. So it can be used to display
 * helper message.
 *
 * An example can be found in user-says of the static node
 *
 * @param {Object} prop Props of the component
 * @param {string} prop.className Custom classname for component
 * @param {node} prop.children Any node you want tooltip to render
 * @param {string} prop.href Any node you want tooltip to render
 * @param {string} prop.linkText Any node you want tooltip to render
 * @param {boolean} prop.isError Changes the tooltip to error type
 * @param {boolean} prop.hideIcon Hides icon of the tooltip
 */
function InfoTooltip({
  className,
  children,
  href,
  linkText,
  isError,
  hideIcon,
}) {
  const errorClassName = isError ? styles.infoTooltipError : '';
  const textClassName = hideIcon ? styles.infoTooltipText : '';
  return (
    <div className={`${styles.infoTooltip} ${errorClassName} ${className}`}>
      {!hideIcon ? (
        <Icon src={isError ? Error : Info} className={styles.infoTooltipIcon} />
      ) : null}
      <div className={textClassName}>
        {children}
        {href ? (
          <a href={href} target="_blank" rel="noreferrer noopener">
            {linkText}
          </a>
        ) : null}
      </div>
    </div>
  );
}

InfoTooltip.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  href: PropTypes.string,
  linkText: PropTypes.string,
  isError: PropTypes.bool,
  hideIcon: PropTypes.bool,
};

InfoTooltip.defaultProps = {
  className: '',
  children: null,
  href: '',
  linkText: 'Link',
  isError: false,
  hideIcon: false,
};

export default InfoTooltip;
